<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaProfissoes"
        sort-name="nome"
        :title-table="$t('Professions')"
        module="professionsSettingsModule"
        :show-btn-add="verificarPermissao('ROLE_ADMIM_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_ADMIM_DELETAR')"
        @add="addNew"
        @edit="edit"
      />
      <form-profession v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormProfession from './forms/FormProfession.vue'
import { verificarPermissao } from '@/auth/utils'

export default {
  name: 'Professions',
  components: {
    BRow,
    BCol,
    TableComponents,
    FormProfession
  },
  computed: {
    ...mapState('professionsSettingsModule', {
      listaProfissoes: (state) => state.listaProfissoes
    })
  },
  data() {
    return {
      verificarPermissao,
      showForm: false,
      columns: [
        {
          label: this.$t('id'),
          field: 'id'
        },
        {
          label: this.$t('Description'),
          field: 'nome'
        },
        {
          label: 'CBO',
          field: 'cbo'
        },
        {
          label: this.$t('Active'),
          field: 'ativo'
        },
        {
          label: this.$t('Action'),
          field: 'action'
        }
      ],
      pageConfig: {
        page: 1,
        size: 10,
        sort: 'nome',
        order: 'asc'
      }
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch(
        'professionsSettingsModule/prepareToEditProfession',
        data
      )
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    }
  }
}
</script>
